// extracted by mini-css-extract-plugin
export default {"zoomModal":"Q6-z","image":"R6-z","button":"S6-z","isOverlayShown":"T6-z"};